const TwoFactorModel = {
  namespace: "twoFactor",
  state: {
    token: null,
    userId: null,
    email: null,
    password: null,
  },
  reducers: {
    setTwoFactorData(state, { payload }) {
      return {
        ...state,
        token: payload.token,
        userId: payload.userId,
        email: payload.email,
        password: payload.password,
      };
    },
    clearTwoFactorData() {
      return {
        token: null,
        userId: null,
        email: null,
        password: null,
      };
    },
  },
};

export default TwoFactorModel;
